import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { featureFlags } from "./featureFlags/featureFlags";

export function UI2SelectionPage() {
  const [enabled, setEnabled] = useState(() => featureFlags.enabled("packages2.0") && featureFlags.enabled("login2.0"));

  function handleChange(checked: boolean) {
    if (checked) {
      featureFlags.admin.enable("packages2.0");
      featureFlags.admin.enable("login2.0");
      featureFlags.admin.enable("loyalty-points");
      featureFlags.admin.enable("appbar2.0");
    } else {
      featureFlags.admin.disable("packages2.0");
      featureFlags.admin.disable("login2.0");
      featureFlags.admin.disable("loyalty-points");
      featureFlags.admin.disable("appbar2.0");
    }
    setEnabled(checked);
    window.location.reload();
  }

  return (
    <Box sx={{ maxWidth: 480, mx: "auto", mt: 8, px: 3 }}>
      <Typography variant="h5" gutterBottom>
        Ustawienia wyglądu
      </Typography>
      <FormControlLabel
        control={<Switch checked={enabled} onChange={(e) => handleChange(e.target.checked)} />}
        label="Nowy wygląd strony"
      />
    </Box>
  );
}
